export function footerToggle() {
    const $menuItem = $(".footer-column li");
    const $menuDropdown = $(".footer-column").find(".list");
    $menuItem.each(function () {
        const $thisItem = $(this);
        if ($thisItem.hasClass("footer-item-has-children")) {
            $thisItem.find(">a, >h6").after("<button type='button' class='icon-toggle'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M4.375 2.625V3.5H9.88313L2.625 10.7581L3.24187 11.375L10.5 4.11687V9.625H11.375V2.625H4.375Z' fill='#111111'/></svg></button>");
        }
    });
    $menuItem.find(".icon-toggle").on("click", function () {
        const $thisDropdown = $(this).parents(".footer-item-has-children").find(".list");
        $thisDropdown.slideToggle(500);
        $menuDropdown.not($thisDropdown).slideUp(500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/footerToggle.js